
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject
} from '@angular/core';
import { ButtonParams, ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { NGXLogger } from 'ngx-logger';
import { ButtonFactoryService } from './button-factory.service';

@Component({
  selector: 'jmkw-button-host',
  standalone: true,
  imports: [],
  template: `<div id="right-menu-buttons">
    <ng-container #buttonHost></ng-container>
  </div>`,
  styleUrls: ['./button-host.component.scss'],
  providers: [ButtonFactoryService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonHostComponent implements OnInit {
  private readonly _logger = inject(NGXLogger);
  private readonly _buttonFactory = inject(ButtonFactoryService);
  private _destroyRef = inject(DestroyRef);

  private _buttonMap: ExtendedMap<ButtonParams> | undefined;

  @Input() set buttonMap(buttonMap: ExtendedMap<ButtonParams>) {
    this._buttonMap = buttonMap;
    this.updateButtons();
  }

  constructor() {
    // Setup cleanup on component destruction (navigation)
    this._destroyRef.onDestroy(() => {
      this._buttonFactory.buttonHost = null; // Setting to null will trigger clearAllButtons
    });
  }

  ngOnInit() {
    // Initial button instantiation if buttonMap is already set
    this.updateButtons();
  }

  @ViewChild('buttonHost', { read: ViewContainerRef }) set buttonHost(
    viewContainerRef: ViewContainerRef
  ) {
    this._buttonFactory.buttonHost = viewContainerRef;
    this.updateButtons(); // Update buttons when the host is set
  }

  private updateButtons() {
    if (this._buttonMap) {
      if (this._buttonFactory.buttonHost) {
        this._buttonFactory.instantiateButtons(this._buttonMap);
      } else {
        this._logger.debug('buttonHost not yet available');
      }
    } else {
      this._logger.debug('buttonMap is undefined or null');
    }
  }
}
